import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import HomeIcon from "@material-ui/icons/Home";
import { NavLink, useHistory } from "react-router-dom";
import { RouteService } from "../../services/route.service";
import PersonIcon from "@material-ui/icons/Person";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import { useDispatch, useSelector } from "react-redux";
import Profile from "../Profile/Profile";
import {Button, Grid, IconButton} from "@material-ui/core";
import { getCustomer } from "../../store/home/selector";
import ErrorModal from "../Modals/ErrorModal";
import Text from "../Text/Text";
import CloseIcon from "@material-ui/icons/Close";
import LockIcon from "@material-ui/icons/Lock";
import moment from "moment";
import { getSystemAlert } from "../../store/systemAlert/action";

const useStyles = makeStyles({
  home: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: 0,
    width: "60px",
    height: "100%",
    color: '#3f51b5',
    textDecoration: 'none',
    borderRadius: 0,
    '&:hover': {
      background: "transparent"
    }
  },
  active: {
    background: "#dde9ff",
    boxShadow: "1px 0 1px 1px #ccc",
    borderBottom: "3px solid #3f51b5",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: '#3f51b5',
    '&:hover': {
      background: "#dde9ff"
    }
  },
  activeLinks: {
    background: "#dde9ff",
    boxShadow: "1px 0 1px 1px #ccc",
    borderBottom: "4px solid #3f51b5",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "16vw",
  },
  navClass: {
    color: "#3f51b5",
    textDecoration: "none!mportant",
    width: "16vw",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  userContainer: {
    borderLeft: "1px solid gray",
    width: "60px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  text: {
    fontWeight: 700,
  },
  Decoration: {
    textDecoration: "none",
  },
  dbFlex: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "#ff0",
    fontWeight: "bold",
    position: "relative",
    marginBottom: "5px",
  },
  securityContauner: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    paddingRight: "15px",
    gap: "10px",
  },
  iconColor: {
    color: "white",
  },
  texts: {
    color: "white",
    fontSize: "12px",
  },
  center: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  navLink: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background:
      "transparent linear-gradient(180deg, #1F4A98 0%, #10254C 100%) 0% 0% no-repeat padding-box",
    height: "28px",
    borderRadius: "8px",
    padding: "2px 15px",
    marginLeft: "5px",
  },
  flexCenter: {
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    background:
      "transparent linear-gradient(180deg, #1F4A98 0%, #10254C 100%) 0% 0% no-repeat padding-box",
    boxShadow: "2px 5px 6px #00000029",
    height: "28px",
    padding: "2px 8px",
    borderRadius: "10px",
    textDecoration: "none",
    marginRight: "25px"
  },
  fullHeight: {
    height: "100%",
  },
  hideButton: {
    marginLeft: '10px',
    cursor: 'pointer',
    background: 'transparent',
    border: 'none',
    fontSize: '18px',
    fontWeight: 'bold',
  },
  profileButton: {
    '&:hover': {
      background: "transparent"
    }
  }
});

const NavigationBar = (props) => {
  let homeStore = useSelector((state) => state["homeState"]);
  const customerName = useSelector(getCustomer);
  const history = useHistory();
  const [profileOpen, setProfileOpen] = React.useState(null);
  const dispatch = useDispatch();
  const userDetailss = useSelector(
    (state) => state?.loginState?.citationEnabled?.citationsEnabled
  );
  const StylingItem = props.StylingItem;
  const handleProfile = (event) => {
    setProfileOpen(event.currentTarget);
  };
  const handleClose = () => {
    setProfileOpen(null);
  };
  const classes = useStyles();
  var isCitationEnabled = false;

  try {
    isCitationEnabled = userDetailss;
  } catch (e) { }

  const mainContainer = {
    width: "100%",
    background: "#f5cd1c",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: "1px 0 1px 1px #ccc",
    height: "50px",
  };
  const [hiddenAlerts, setHiddenAlerts] = React.useState(new Set());
  const [alertMessage, setAlertMessage] = React.useState();
  const [toggle, setToggle] = React.useState(false);
  
  const handleToggle = () => {
    setToggle((prev) => !prev);
  };
  
  const systemAlertMessage = useSelector(
    (state) => state?.SystemAlertReducer?.systemAlert
  );

  React.useEffect(() => {
    setAlertMessage(systemAlertMessage);
  }, [systemAlertMessage]);

  React.useEffect(() => {
    dispatch(getSystemAlert());
  }, []);
  
  const currentDatetime = Date();

  const clientName = useSelector(
    (state) => state.loginState?.userContext?.user?.userName
  );

  //Start navigation Alert
  const getAlerts = () => {
    if (!Array.isArray(alertMessage) || alertMessage.length === 0) return null;

    const handleHideAlert = (alertId) => {
      setHiddenAlerts((prev) => new Set(prev).add(alertId));
    };

    // Filter and map valid alerts
    const validAlerts = alertMessage
      .filter((alert) => {
        const isBetween = moment(currentDatetime).isBetween(alert.startDate, alert.endDate);
        const isNotHidden = !hiddenAlerts.has(alert.id || alert);
        return alert.enabled && isBetween && isNotHidden;
      })
      .map((alert, index) => (
        <div key={alert.id || index} className={classes.dbFlex}>
          <span
            id={`editor-text-id-${index}`}
            className="ql-editor"
            style={{ padding: '7px', flex: 1 }}
            dangerouslySetInnerHTML={{ __html: alert.body }}
          />
          <button
            onClick={() => handleHideAlert(alert.id || index)}
            className={classes.hideButton}
            aria-label="Hide alert"
          >
            <CloseIcon/>
          </button>
        </div>
      ));

    return validAlerts.length > 0 ? <div aria-live="assertive">{validAlerts}</div> : null;
  };
  //End code

  return (
    <>
      <div
        className="mobile_nav"

        style={{
          ...mainContainer,
          ["background"]: StylingItem && StylingItem.navigationBarColor,
          textDecoration: "none",
          marginBottom: "3px",
          boxShadow: "0 3px #d5d5d5",
        }}
      >
        <IconButton
          component={NavLink}
          to={RouteService.dashboard(homeStore.customerName)}
          className={classes.home}
          aria-label="Home"
          activeClassName={classes.active}
          style={{ color: StylingItem?.navigationFontColor }}

        >
            <HomeIcon
              style={{color: StylingItem?.navigationFontColor}}
            />
        </IconButton>
        <button
          type="button"
          className="humb"
          aria-label="Toggle navigation menu"
          aria-expanded={!toggle}
          aria-controls="mobile-nav-menu"
          style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', font: 'inherit', color: 'inherit', WebkitAppearance: 'none' }}
          onClick={handleToggle}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            data-name="Layer 1"
            viewBox="0 0 64 64"
            aria-hidden="true"
          >
            <line
              x2="64"
              y1="15.95"
              y2="15.95"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="5"
              strokeWidth="6"
            />
            <line
              x2="64"
              y1="32.15"
              y2="32.15"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="5"
              strokeWidth="6"
            />
            <line
              x2="64"
              y1="48.05"
              y2="48.05"
              fill="none"
              stroke="#fff"
              strokeMiterlimit="5"
              strokeWidth="6"
            />
          </svg>
        </button>
        <nav id="mobile-nav-menu" aria-label="Main navigation" style={{height: toggle ? undefined : '100%'}} className={toggle ? 'nav-open' : ''}>
          <NavLink
            style={{ textDecoration: "none", color: StylingItem && StylingItem.navigationFontColor }}
            to={RouteService.buyPermits(homeStore.customerName)}
            className={classes.navClass}
            activeClassName={classes.activeLinks}
          >
            <Text className={classes.text} >Order Permits</Text>
          </NavLink>
          <NavLink
              style={{ textDecoration: "none", color: StylingItem && StylingItem.navigationFontColor }}
            to={RouteService.viewOrders(homeStore.customerName)}
            className={classes.navClass}
            activeClassName={classes.activeLinks}
          >
            <Text className={classes.text}>View Orders</Text>
          </NavLink>
          {isCitationEnabled && (
            <NavLink
                style={{ textDecoration: "none", color: StylingItem && StylingItem.navigationFontColor }}
              to={RouteService.citation(homeStore.customerName)}
              className={classes.navClass}
              activeClassName={classes.activeLinks}
            >
              <Text className={classes.text}>Manage Citations</Text>
            </NavLink>
          )}
        </nav>
        <div
          className={`${classes.userContainer} ${classes.fullHeight} ${history.location.pathname === RouteService.profilePage(customerName)
            ? classes.active
            : ""
          }`}
        >
          {clientName === "clientadmin" ?
            <div className={classes.securityContauner}>
              <NavLink
                to={RouteService.login(homeStore.customerName)}
                className={classes.flexCenter}
              >
                <LockIcon className={classes.iconColor}  />
                <div className={classes.texts} style={{ paddingRight: "10px" }}>
                  Login
                </div>
              </NavLink>
            </div>
            :
            <div className={`${classes.center} ${classes.fullHeight}`}>
              <Grid container justify="center" alignItems="center" className={classes.fullHeight}>
                <Profile open={profileOpen} onClose={handleClose}/>
                <Button
                  title="Account Page"
                  onClick={handleProfile}
                  size="large"
                  className={[classes.fullHeight, classes.profileButton]}
                  disableRipple
                >
                  <PersonIcon color="primary" style={{ color: StylingItem && StylingItem.navigationFontColor }}/>
                  <ArrowDropDownIcon color="primary" style={{ color: StylingItem && StylingItem.navigationFontColor }}/>
                </Button>
              </Grid>
            </div>
          }
        </div>
      </div>
      <ErrorModal />
      {getAlerts()}
    </>
  );
};
export default NavigationBar;